/** Owner → Settings → Email alerts (1.4 P03). */
import React from 'react';
import { api, apiGet } from '../../src/api/client';
import EmailAlertsScreen, { type EmailAlertsApiClient } from '../../src/screens/EmailAlertsScreen';

const ownerClient: EmailAlertsApiClient = {
  get: (url) => apiGet(url),
  put: (url, body) => api(url, { method: 'PUT', body }),
};

export default function OwnerEmailAlertsRoute() {
  return <EmailAlertsScreen client={ownerClient} />;
}
